module.exports = __webpack_public_path__ + "static/img/cont58_06.b2ad652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_06.jpg
// module id = 2/8O
// module chunks = 0